import { gql } from '@apollo/client';

export const CREATE_BOOKING = gql`
  mutation CreateBooking($input: BookingInput!) {
    createBooking(input: $input) {
      id
      status
      statutReservation
      travelerCount
      totalPrice
      contactInfo
      specialRequests
      package {
        id
        title
        commission
        agency {
          id
          name
          logo
        }
      }
      packageId
      formula {
        id
        name
      }
      formulaId
      client {
        id
        firstName
        lastName
      }
      clientId
      createdAt
      updatedAt
      nbrAdulte
      nbrEnfant
      nbrBebe
      nbrChambre
      nom
      prenom
      telephone
      mail
      typeReservation
      personnes
      bebes
      chambres
      paiement
      montantAvance
      montantPaye
      statutDisponibilite
      delaiOption
    }
  }
`;

export const ACCEPT_BOOKING = gql`
  mutation AcceptBooking($id: Int!) {
    acceptBooking(id: $id) {
      id
      status
      statutReservation
      statutDisponibilite
      package {
        id
        title
        commission
        agency {
          id
          name
          logo
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const REJECT_BOOKING = gql`
  mutation RejectBooking($id: Int!) {
    rejectBooking(id: $id) {
      id
      status
      statutReservation
      statutDisponibilite
      package {
        id
        title
        commission
        agency {
          id
          name
          logo
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_BOOKING = gql`
  mutation UpdateBooking($id: Int!, $input: BookingInput!) {
    updateBooking(id: $id, input: $input) {
      id
      status
      statutReservation
      travelerCount
      totalPrice
      contactInfo
      specialRequests
      package {
        id
        title
        commission
        agency {
          id
          name
          logo
        }
      }
      packageId
      formula {
        id
        name
      }
      formulaId
      client {
        id
        firstName
        lastName
      }
      clientId
      createdAt
      updatedAt
      nbrAdulte
      nbrEnfant
      nbrBebe
      nbrChambre
      nom
      prenom
      telephone
      mail
      typeReservation
      personnes
      bebes
      chambres
      paiement
      montantAvance
      montantPaye
      statutDisponibilite
      delaiOption
    }
  }
`;

export const DELETE_BOOKING = gql`
  mutation DeleteBooking($id: Int!) {
    deleteBooking(id: $id)
  }
`;

export const CANCEL_BOOKING = gql`
  mutation CancelBooking(
    $id: Int!
    $annulationPar: String
    $clientEmail: String
    $agencyId: Int
  ) {
    cancelBooking(
      id: $id
      annulationPar: $annulationPar
      clientEmail: $clientEmail
      agencyId: $agencyId
    ) {
      id
      status
      statutReservation
      statutDisponibilite
      annulationPar
      annuleLe
      package {
        id
        title
        commission
        agency {
          id
          name
          logo
        }
      }
      createdAt
      updatedAt
    }
  }
`; 

export const REQUEST_MODIFICATIONS = gql`
  mutation RequestModifications($id: Int!) {
    requestModifications(id: $id) {
      id
      status
      statutReservation
      statutDisponibilite
      package {
        id
        title
        commission
        agency {
          id
          name
          logo
        }
      }
      createdAt
      updatedAt
    }
  }
`; 